import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Scale, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/console");
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/console";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F4EFE4] grain-overlay flex flex-col">
      <div className="p-6 md:p-10">
        <Link to="/" className="inline-flex items-center gap-2 text-stone-500 hover:text-amber-600 transition-colors text-sm" data-testid="login-back-home">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-8"><Link to="/" aria-label="Torna alla home" data-testid="nav-home-logo"><Brand /></Link></div>
          <div className="card-luxe rounded-2xl p-8 md:p-10 animate-fade-up">
            <div className="w-14 h-14 rounded-full border border-amber-500/40 bg-[#F4EFE4] flex items-center justify-center mx-auto mb-6 gold-glow">
              <Scale className="w-7 h-7 text-amber-600" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif text-3xl text-stone-900 text-center mb-2">Console Staff</h1>
            <p className="text-stone-500 text-center text-sm mb-8">
              Accesso riservato ad avvocati e collaboratori dello Studio.
            </p>
            <Button
              onClick={handleGoogleLogin}
              data-testid="google-login-btn"
              className="w-full h-12 bg-amber-500 hover:bg-amber-400 text-[#221C12] font-semibold rounded-xl transition-colors"
            >
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
                <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Accedi con Google
            </Button>
            <p className="text-stone-500 text-xs text-center mt-6">
              Utilizzando l'accesso accetti le policy interne dello Studio.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
